import React, { Component } from 'react'
import Container from '../common/application_container'
import InvoiceTable from './invoiceTable'

export default class InvoiceIndex extends Component {
    render() {
        return (
            <Container title="Invoice" subTitle="Table">
                <InvoiceTable />
            </Container>
        )
    }
}
